import { z } from 'zod';
import { line, pt } from './print-fields';

/**
 * The comments and remarks blocks under a results table.
 *
 * Split out of `print-template.ts` on length alone — that file is the whole
 * document shape and sits against the 400-line ceiling, and this is a
 * self-contained sub-schema with no other reader.
 */
export const printCommentsSchema = z.object({
  enabled: z.boolean().default(true),
  title: line('Comments'),
  size: pt(8.5),
});

/** The remarks block, printed above the comments. It never has a heading. */
export const printRemarksSchema = z.object({
  enabled: z.boolean().default(true),
  size: pt(8.5),
});
